<div class="super-admin-container">
    <!-- Header -->
    <div class="config-header">
        <div class="header-content">
            <h1 class="config-title">
                <fa-icon [icon]="icons.faCrown" class="title-icon"></fa-icon>
                Super Admin - Board Management
            </h1>
            <p class="config-subtitle">Manage purchased feature flags for all boards in the system</p>
        </div>
    </div>

    <!-- Search Filter -->
    <div class="search-container">
        <div class="search-bar">
            <fa-icon [icon]="icons.faSearch" class="search-icon"></fa-icon>
            <input type="text" 
                   [(ngModel)]="searchTerm" 
                   (ngModelChange)="applyFilter()"
                   placeholder="Search by board ID..."
                   class="search-input">
            <button *ngIf="searchTerm" 
                    class="clear-btn" 
                    (click)="searchTerm = ''; applyFilter()">
                <fa-icon [icon]="icons.faTimes"></fa-icon>
            </button>
        </div>
        <div class="board-count">
            <span class="count-badge">{{ filteredBoards.length }}</span> of {{ boards.length }} boards
        </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="loading" class="loading-container">
        <fa-icon [icon]="icons.faSpinner" [spin]="true" class="loading-spinner"></fa-icon>
        <p>Loading boards...</p>
    </div>

    <!-- Boards Table -->
    <div *ngIf="!loading" class="table-container">
        <table class="boards-table">
            <thead>
                <tr>
                    <th class="col-id">Board ID</th>
                    <th class="col-flag">In-Store Channel</th>
                    <th class="col-flag">Phone Channel</th>
                    <th class="col-flag">Internet Channel</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let board of filteredBoards" [class.saving]="savingBoardId === board.id">
                    <td class="col-id">
                        <fa-icon [icon]="icons.faChalkboard" class="board-icon"></fa-icon>
                        <code>{{ board.id }}</code>
                    </td>
                    <td class="col-flag">
                        <button class="toggle-btn" 
                                [class.active]="board.config?.instoreChannelPurchased !== false"
                                [disabled]="savingBoardId !== null"
                                (click)="togglePurchasedFlag(board.id, 'instoreChannelPurchased', board.config?.instoreChannelPurchased !== false)">
                            <fa-icon *ngIf="savingBoardId === board.id" [icon]="icons.faSpinner" [spin]="true"></fa-icon>
                            <ng-container *ngIf="savingBoardId !== board.id">
                                <fa-icon [icon]="board.config?.instoreChannelPurchased !== false ? icons.faToggleOn : icons.faToggleOff"></fa-icon>
                                {{ board.config?.instoreChannelPurchased !== false ? 'Purchased' : 'Not Purchased' }}
                            </ng-container>
                        </button>
                    </td>
                    <td class="col-flag">
                        <button class="toggle-btn" 
                                [class.active]="board.config?.phoneChannelPurchased"
                                [disabled]="savingBoardId !== null"
                                (click)="togglePurchasedFlag(board.id, 'phoneChannelPurchased', board.config?.phoneChannelPurchased || false)">
                            <fa-icon *ngIf="savingBoardId === board.id" [icon]="icons.faSpinner" [spin]="true"></fa-icon>
                            <ng-container *ngIf="savingBoardId !== board.id">
                                <fa-icon [icon]="board.config?.phoneChannelPurchased ? icons.faToggleOn : icons.faToggleOff"></fa-icon>
                                {{ board.config?.phoneChannelPurchased ? 'Purchased' : 'Not Purchased' }}
                            </ng-container>
                        </button>
                    </td>
                    <td class="col-flag">
                        <button class="toggle-btn"
                                [class.active]="board.config?.internetChannelPurchased"
                                [disabled]="savingBoardId !== null"
                                (click)="togglePurchasedFlag(board.id, 'internetChannelPurchased', board.config?.internetChannelPurchased || false)">
                            <fa-icon *ngIf="savingBoardId === board.id" [icon]="icons.faSpinner" [spin]="true"></fa-icon>
                            <ng-container *ngIf="savingBoardId !== board.id">
                                <fa-icon [icon]="board.config?.internetChannelPurchased ? icons.faToggleOn : icons.faToggleOff"></fa-icon>
                                {{ board.config?.internetChannelPurchased ? 'Purchased' : 'Not Purchased' }}
                            </ng-container>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- No Results -->
        <div *ngIf="filteredBoards.length === 0 && !loading" class="no-results">
            <fa-icon [icon]="icons.faSearch" class="no-results-icon"></fa-icon>
            <p *ngIf="searchTerm">No boards found matching "{{ searchTerm }}"</p>
            <p *ngIf="!searchTerm">No boards in the system</p>
        </div>
    </div>

    <!-- Footer Note -->
    <div class="config-footer">
        <p>
            <fa-icon [icon]="icons.faShieldAlt"></fa-icon>
            Changes are saved immediately. Purchased flags control which premium features are available to each board.
        </p>
    </div>
</div>
